import { PageSection } from 'Components/Layout';
import { Button, ButtonGroup } from 'Components/Core';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Data/ReduxViewModels/Ags/WorkOrder';

const WorkOrderRunAgsExportSection: React.FC = () => {
  const dispatch = useDispatch();
  const busyState = useSelector((state) => state.agsWorkOrderExport.status?.busyState);

  return (
    <PageSection heading="AGS Export" id="AgsWorkOrderExportPage">
      <ButtonGroup>
        <Button onClick={() => dispatch(actions.runNewExport())} loading={busyState}>
          Run Export
        </Button>
      </ButtonGroup>
    </PageSection>
  );
};

export default WorkOrderRunAgsExportSection;
